<template>
  <v-container>
      <iframe :src="url" width="100%" height="600"></iframe>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            resource: "getCurrentResource"
        }),
        url() {
            return this.resource.link;
        }
    },

    // mounted() {
    //     this.actionClickOnResource({ resourceId: this.resource.resourcesId, activityId: this.resource.activity.activityLessonId});
    // },

    // methods: {
    //     ...mapActions({
    //     actionClickOnResource: "actionClickOnResource"
    //     })
    // }
}
</script>

<style>

</style>